module.exports = __webpack_public_path__ + "static/media/catalogue-pattern.07fa0ad1.png";